import {Button, Divider} from '@material-ui/core';
import {createStyles, makeStyles} from '@material-ui/core/styles';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {lookupModality} from 'features/instance/component/StageGrid';
import React from 'react';
import useLoadAttended from '../../../components/hooks/useLoadDetails';
import {i18n2} from '../../i18n/i18n';
import {AttendedSectorSchema} from '../model/AttendedSector';

const SectorReadOnlyDetail = ({history, location}: any) => {
  const styles = useStyles();
  return (
    <>
      <div className={styles.header}>
        <h2 className={styles.title}>
          {i18n2._('Detalle del sector:')} {location.state.data.name}
        </h2>
        <Divider variant="middle" className={styles.divider} />
        <div className={styles.button}>
          <Button
            title={i18n2._('Volver')}
            variant="contained"
            onClick={history.goBack}
            size="medium"
            color={'primary'}
          >
            {i18n2._('Volver')}
          </Button>
        </div>
      </div>
      <SectorsReadOnlyGrid id={location.state.key} />
    </>
  );
};

const SectorsReadOnlyGrid = ({id}: any) => {
  const loadAttended = useLoadAttended('instanceJoinedWithSectors', id);

  return (
    <IntegrityRoleGrid
      schema={AttendedSectorSchema()}
      dataSource={loadAttended}
      id={['iD_Instance', 'iD_Course', 'employee_Nr']}
      height="65vh"
      allowIntegrity={false}
      allowActions={false}
      exportName="Sector-detail-export"
    >
      <Column
        caption={i18n2._('#Instancia')}
        dataField="iD_Instance"
        width="5%"
      />
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" width="5%" />
      <Column
        caption={i18n2._('Numero de empleado')}
        dataField="employee_Nr"
        visible={false}
      />
      <Column
        caption={i18n2._('Nombre del empleado')}
        dataField="name"
        width="9%"
      />
      <Column caption={i18n2._('CWID')} dataField="cwid" width="5%" />
      <Column caption={i18n2._('Sector')} dataField="sector_Name" width="13%" />
      <Column
        caption={i18n2._('Nombre del curso')}
        dataField="name_Course"
        width="40%"
      />
      <Column
        caption={i18n2._('Tipo de curso')}
        dataField="name_Type"
        width="7%"
      />
      <Column
        caption={i18n2._('Fecha de expiración')}
        dataField="expiration_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.expiration_Date)}
        width="8%"
      />
      <Column
        caption={i18n2._('Fecha de Vigencia')}
        dataField="dateVig"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateVig)}
        visible={false}
      />
      <Column
        caption={i18n2._('Instructor')}
        dataField="instructor"
        visible={false}
      />
      <Column caption={i18n2._('Modality')} dataField="modality" width="7%">
        <Lookup dataSource={lookupModality} valueExpr="id" displayExpr="name" />
      </Column>
    </IntegrityRoleGrid>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    header: {
      position: 'relative',
    },
    title: {
      textAlign: 'center',
    },
    divider: {
      marginBottom: 10,
    },
    button: {
      position: 'absolute',
      paddingRight: 30,
      right: 0,
      top: 0,
      textAlign: 'right',
    },
  }),
);

export default SectorReadOnlyDetail;
